import React from "react";
import { motion } from "framer-motion";
import { Check, Sparkles } from "lucide-react";
import { Link } from "react-router-dom";
import { tarifs } from "../data/mock"; // On pioche directement vos vrais prix ici !

const TarifsPage = () => {
  return (
    <div className="pt-24 pb-16 min-h-screen bg-[#F6F7F1]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <div className="flex items-center justify-center gap-3 mb-6">
            <div className="h-px w-16 bg-[#D4AF37]" />
            <Sparkles className="w-5 h-5 text-[#D4AF37]" />
            <div className="h-px w-16 bg-[#D4AF37]" />
          </div>
          <h1 className="font-playfair text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Nos Tarifs & Formules
          </h1>
          <p className="text-gray-500 text-lg max-w-2xl mx-auto">
            Des créations uniques sur mesure pour s'adapter parfaitement à votre budget et à vos envies.
          </p>
        </motion.div>

        {/* Pricing Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 items-start">
          {tarifs.map((plan, index) => {
            const details = Array.isArray(plan.details)
              ? plan.details.filter((detail) => typeof detail === "string")
              : [];
            return (
            <motion.div
              key={plan.id}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className={`bg-white rounded-3xl p-8 relative shadow-sm hover:shadow-md transition-all duration-300 border-2 ${
                plan.popular ? "border-[#E5007D]" : "border-transparent"
              }`}
            >
              {plan.popular && (
                <span className="absolute top-0 right-8 transform -translate-y-1/2 bg-[#E5007D] text-white text-xs font-semibold px-4 py-1.5 rounded-full uppercase tracking-wider">
                  Populaire
                </span>
              )}
              
              <div className="mb-6">
                <h3 className="font-playfair text-2xl font-bold text-gray-900 mb-2">{plan.name}</h3>
                <p className="text-gray-500 text-sm h-10">{plan.description}</p>
                <div className="mt-4 flex items-baseline text-gray-900">
                  <span className="text-3xl font-bold tracking-tight font-playfair">{plan.priceRange}</span>
                </div>
              </div>

              <div className="h-px bg-gray-100 my-6" />

              <ul className="space-y-4 mb-8">
                {details.map((detail, idx) => (
                  <li key={idx} className="flex items-start gap-3 text-sm text-gray-600">
                    <Check className="w-4 h-4 text-[#E5007D] shrink-0 mt-0.5" />
                    <span>{detail}</span>
                  </li>
                ))}
              </ul>

              <Link
                to="/commande"
                className={`w-full block text-center py-3 px-6 rounded-xl font-medium text-sm transition-all duration-300 ${
                  plan.popular
                    ? "bg-[#E5007D] text-white hover:bg-[#c4006b] shadow-md shadow-[#E5007D]/25"
                    : "bg-gray-50 text-gray-700 hover:bg-gray-100"
                }`}
              >
                Demander un devis
              </Link>
            </motion.div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default TarifsPage;
